import { render, staticRenderFns } from "./PickupForm.vue?vue&type=template&id=5c37e827&scoped=true&lang=pug&"
import script from "./PickupForm.vue?vue&type=script&lang=js&"
export * from "./PickupForm.vue?vue&type=script&lang=js&"
import style0 from "./PickupForm.vue?vue&type=style&index=0&id=5c37e827&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c37e827",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VSelect,VTextField})
